import { deserialize, serialize } from "node:v8";

const HEADER_BYTES = 4;
const MAX_FRAME_BYTES = 32 * 1024 * 1024;

export function encodeSidecarFrame(value: unknown): Buffer {
  const payload = serialize(value);
  if (payload.byteLength > MAX_FRAME_BYTES) {
    throw new Error("Mentis sidecar IPC frame exceeded the safety limit");
  }
  const frame = Buffer.allocUnsafe(HEADER_BYTES + payload.byteLength);
  frame.writeUInt32BE(payload.byteLength, 0);
  payload.copy(frame, HEADER_BYTES);
  return frame;
}

export class SidecarFrameDecoder {
  #buffer = Buffer.alloc(0);

  push(chunk: Uint8Array): unknown[] {
    this.#buffer = Buffer.concat([this.#buffer, chunk]);
    const values: unknown[] = [];
    while (this.#buffer.byteLength >= HEADER_BYTES) {
      const length = this.#buffer.readUInt32BE(0);
      if (length > MAX_FRAME_BYTES) {
        throw new Error("Mentis sidecar IPC frame exceeded the safety limit");
      }
      const frameLength = HEADER_BYTES + length;
      if (this.#buffer.byteLength < frameLength) break;
      values.push(deserialize(this.#buffer.subarray(HEADER_BYTES, frameLength)));
      this.#buffer = this.#buffer.subarray(frameLength);
    }
    return values;
  }
}
